// frontend/src/services/api/creditAPI.js
import api from "./index";

// frontend/src/services/api/creditAPI.js
// const creditAPI = {
//   getBalance: () => api.get("/credits/balance"),
//   createPaymentIntent: (data) =>
//     api.post("/payment/create-payment-intent", data),
//   verifyPayment: (sessionId) => api.post(`/payment/verify/${sessionId}`),
// };

const creditAPI = {
  getBalance: () => api.get("/credits/balance"),
  createPaymentIntent: (data) =>
    api.post("/payment/create-payment-intent", data),
  verifyPayment: (sessionId) => api.post(`/payment/verify/${sessionId}`),

  // Add PayPal methods
  createPayPalOrder: (data) => api.post("/payment/paypal/create-order", data),
  capturePayPalOrder: (data) => api.post("/payment/paypal/capture-order", data),

  // Add Airwallex methods
  createAirwallexIntent: (data) =>
    api.post("/payment/airwallex/create-intent", data),
  confirmAirwallexPayment: (data) =>
    api.post("/payment/airwallex/confirm", data),
  getAirwallexIntent: (intentId) =>
    api.get(`/payment/airwallex/intent/${intentId}`),
  verifyAndProcessAirwallexPayment: (data) =>
    api.post("/payment/airwallex/verify-and-process", data),

  // Airwallex simulation methods (development only)
  simulateAirwallexSuccess: (data) =>
    api.post("/payment/airwallex/simulate/payment-success", data),
  simulateAirwallexFailure: (data) =>
    api.post("/payment/airwallex/simulate/payment-failure", data),
  simulateAirwallexAttempt: (data) =>
    api.post("/payment/airwallex/simulate/payment-attempt", data),
  simulateAirwallexCancelled: (data) =>
    api.post("/payment/airwallex/simulate/payment-cancelled", data),
};
export default creditAPI;
